import { render, staticRenderFns } from "./trip-list.html?vue&type=template&id=03192952&scoped=true&"
import script from "./trip-list.js?vue&type=script&lang=js&"
export * from "./trip-list.js?vue&type=script&lang=js&"
import style0 from "./trip-list.scss?vue&type=style&index=0&id=03192952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03192952",
  null
  
)

export default component.exports